// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ClaimModal_modalBody__2qv_w","headerDiv":"ClaimModal_headerDiv__1tKsO","BtnDiv":"ClaimModal_BtnDiv__11Q2L","verifyCodeDiv":"ClaimModal_verifyCodeDiv__3lAzj"};